export default __webpack_public_path__ + "static/media/pf.c6c003e2.svg";